import { createContext, useContextSelector } from 'use-context-selector';

export enum DeepLinkPhase {
  Idle = 'idle',
  Locating = 'locating',
  Found = 'found',
  NotFound = 'notFound',
}

export interface MessageDeepLinkState {
  targetMessageId: string | null;
  phase: DeepLinkPhase;
  highlightedMessageId: string | null;
}

const IDLE_STATE: MessageDeepLinkState = {
  targetMessageId: null,
  phase: DeepLinkPhase.Idle,
  highlightedMessageId: null,
};

// Defaults to idle so a message rendered outside a thread (tests, previews) needs no provider.
export const MessageDeepLinkContext = createContext<MessageDeepLinkState>(IDLE_STATE);

export function useMessageDeepLink<T>(selector: (s: MessageDeepLinkState) => T): T {
  return useContextSelector(MessageDeepLinkContext, selector);
}
